import instructorActions from "modules/instructor/duck/actions"
import usersActions from "modules/users/duck/actions"

export default {
  instructor: instructorActions,
  users: usersActions,
}
